import React from 'react';
import Helmet from 'react-helmet';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import * as dialog from '../components/UserDialog';
import masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import {
  HEADER_CONSTANTS,
  USER_ROLES,
  USER_VIEW_MODE,
} from '../utilities/constants';
import {
  isTargetRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';

import { UserForm } from '../components/UserForm';
import { MasterPageHeader } from '../components/PageHeader';
import UserApi from '../services/user/UserApi';
import UsersApi from '../services/users/UsersApi';
import { UserService } from '../services/Users';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import _ from 'lodash';

/**
 * 利用者詳細画面
 */
export class UserDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      params: {
        user_role_code: null, // ユーザー種別
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        tel: '', // 電話番号
        email: '', // ユーザーID(メールアドレス)
        company_branch: null, // 支店
        image_url: '', // 画像ファイルアイコン
        block_flag: false,
        block_user_name: '', // アカウント停止したユーザー名
      }, // フォームの値を保持
      blockPermission: false,
      viewerId: LocalStorageService.getUserId(),
      isPrimary: isPrimaryCompanyRoleId(LocalStorageService.getRoleId()),
      isManagerPermission: false,
      hasManagerPermission: true,
      events: {
        showConfirmBlockUnblock: this.showConfirmBlockUnblock,
        showEdit: this.showEdit.bind(this),
        back: this.back.bind(),
      },
    };

    // slideLoaderからの情報を取得
    if (props.view) {
      this.state.userId = props.view.state.id;
    }
    // 本社IDとユーザーIDを取得
    this.companyId = SessionStorageService.getCompanyId(); // 本社ID
    this.userId = LocalStorageService.getUserId(); // ユーザーID
    this.roleId = LocalStorageService.getRoleId(); // ロールID
  }

  componentDidMount() {
    this.onLoad();
    this.settingPermission();
  }

  getHeaderTitle() {
    let title = '利用者詳細';
    if (!this.state.isPrimary) {
      title += '（協力会社）';
    }
    return title;
  }

  /**
   * ユーザー編集画面を表示する
   * */
  showEdit = () => {
    const id = this.state.userId;
    masterSlideLoader.show('UserEdit', { state: { id } });
  };

  showConfirmBlockUnblock = async doBlock => {
    if (this.state.params.integrated) {
      const { result, data } = await LoginUserGroupsService.list({
        user_id: this.state.userId,
      });
      if (result) {
        this.showBlockUnblockIntegratedUserDialog(
          _.get(data, 'entities.users'),
          doBlock
        );
        return;
      }
    }
    if (doBlock) {
      this.showBlockDialog();
    } else {
      this.showUnblockDialog();
    }
  };

  /**
   * アカウント停止ダイアログを表示する
   * */
  showBlockDialog = () => {
    dialogLoader.show(dialog.BlockUser, {
      callback: {
        done: () => {
          this.blockUser();
        },
        cancel: () => {
          dialogLoader.close();
        },
      },
      isPrimary: this.state.isPrimary,
      userRoleCode: this.state.params.user_role_code,
    });
  };

  /**
   * アカウント復旧ダイアログを表示する
   * */
  showUnblockDialog = () => {
    dialogLoader.show(dialog.UnblockUser, {
      callback: {
        done: () => {
          this.unblockUser();
        },
        cancel: () => {
          dialogLoader.close();
        },
      },
      userRoleCode: this.state.params.user_role_code,
    });
  };

  showBlockUnblockIntegratedUserDialog = (listUsersIntegrate, doBlock) => {
    const allowSubmit = !_.some(
      listUsersIntegrate,
      user => user.id === this.state.viewerId
    );
    dialogLoader.show(dialog.BlockUnblockIntegratedUser, {
      listUsersIntegrate,
      doBlock,
      allowSubmit,
      callback: {
        done: () => {
          doBlock ? this.blockUser() : this.unblockUser();
        },
        cancel: () => {
          dialogLoader.close();
        },
      },
    });
  };

  /**
   * 利用者一覧へ戻る
   * */
  back = () => {
    masterSlideLoader.show('Users', { state: { id: 1 } });
  };

  /**
   * ユーザー情報を取得
   */
  async onLoad() {
    try {
      const response = await UserApi.fetch(this.state.userId);
      if (response.result) {
        const params = response.data.entities.user;
        params.user_role_code = params.user_role.code;
        params.company_branch = params.company_branch[0];
        this.setState({ params }, function() {
          const blockPermission = this.hasBlockPermission();
          this.setState({ blockPermission });
        });
      }
    } catch (e) {
      // NOTE
      // 本来であればエラーダイアログで表示すべきだが、
      // 共通化まえは握りつぶしていたのでひとまず、アカウント停止、取り消しと揃えてアラート表示のみ実装
      alert(`エラーです：${e}`);
    }
  }

  /**
   * アカウント停止権限を保持しているかどうかを判定する
   *
   * @return {boolean}
   */
  hasBlockPermission = () => {
    // 【A-161】リリースが延期になった場合、すぐ戻すためコメントアウト
    // // 協力会社の場合はアカウント停止できない
    // if (!this.state.isPrimary) {
    //   return false;
    // }

    // 自分自身のユーザー詳細を閲覧時は、アカウント制御不可
    if (this.state.viewerId === Number(this.state.userId)) {
      return false;
    }

    const role_id = LocalStorageService.getRoleId();

    // 【A-161】リリースが延期になった場合、すぐ戻すためコメントアウト
    // // 本社管理者でログイン時は、全ユーザーに対してアカウント制御が可能
    // if (isTargetRoleId([USER_ROLES.prime], role_id)) {
    //   return true;
    // }

    // 本社管理者、協力会社管理者でログイン時は、全ユーザーに対してアカウント制御が可能
    if (isTargetRoleId([USER_ROLES.prime, USER_ROLES.partner], role_id)) {
      return true;
    }

    // 支店管理者でログイン時は、自支店の現場監督に対してアカウント制御が可能
    const myCompanyBranchId = Number(SessionStorageService.getCompanyBranchId());
    const selectUserRoleCode = this.state.params.user_role_code;

    // A-768の対応で支店管理者や現場監督が本社管理者の詳細情報を確認できるようになった
    // それに伴ったCompanyBranchIdユーザーについてもhasBlockPermissionメソッドが動くようになった
    // CompanyBranchIdを持たない場合は空文字を設定する
    const selectUserCompanyBranchId = _.get(
      this.state,
      'params.company_branch.id',
      ''
    );
    return !!(
      isTargetRoleId([USER_ROLES.branch], role_id) &&
      isTargetRoleId([USER_ROLES.manager], selectUserRoleCode) &&
      myCompanyBranchId === selectUserCompanyBranchId
    );
  };

  /**
   * @description アカウント停止処理
   */
  async blockUser() {
    if (!this.state.blockPermission) {
      dialogLoader.close();
      return;
    }

    const params = this.state.params;
    try {
      let res = await UserService.update(this.state.userId, {
        block_flag: 1,
      });
      if (res.result) {
        params.block_flag = 1;
        // 詳細に戻る
        this.setState({ params });
        await this.onLoad();
        dialogLoader.show(dialog.BlockComplete, {
          callback: {
            cancel: () => {
              dialogLoader.close();
            },
          },
        });
      } else {
        let errorMessage = '';
        if (res.message) {
          errorMessage = res.message;
        } else {
          errorMessage = res.data.message;
        }
        dialogLoader.show(dialog.ErrorDialog, {
          callback: {
            cancel: () => {
              dialogLoader.close();
            },
          },
          message: errorMessage,
        });
      }
    } catch (error) {
      let errorMessage = '';
      if (error.message) {
        errorMessage = error.message;
      } else {
        errorMessage = error.data.message;
      }
      dialogLoader.show(dialog.ErrorDialog, {
        callback: {
          cancel: () => {
            dialogLoader.close();
          },
        },
        message: errorMessage,
      });
    }
  }

  /**
   * @description アカウント復旧処理
   */
  unblockUser() {
    if (!this.state.blockPermission) {
      dialogLoader.close();
      return;
    }

    const params = this.state.params;
    UserService.update(this.state.userId, {
      block_flag: 0,
    })
      .then(res => {
        if (res.result) {
          params.block_flag = 0;
          // 詳細に戻る
          this.setState({ params });
          dialogLoader.show(dialog.UnblockComplete, {
            callback: {
              cancel: () => {
                dialogLoader.close();
              },
            },
          });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else {
            errorMessage = res.data.message;
          }
          dialogLoader.show(dialog.ErrorDialog, {
            callback: {
              cancel: () => {
                dialogLoader.close();
              },
            },
            message: errorMessage,
          });
        }
      })
      .catch(error => {
        let errorMessage = '';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.data.message;
        }
        dialogLoader.show(dialog.ErrorDialog, {
          callback: {
            cancel: () => {
              dialogLoader.close();
            },
          },
          message: errorMessage,
        });
      });
  }

  /**
   * @description 企業管理者＆サービス権限取得
   */
  settingPermission() {
    UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    })
      .then(res => {
        let isManagerPermission = false;
        let hasManagerPermission = true;
        if (res.result === true) {
          if (res.data.total === 0) {
            hasManagerPermission = false;
          } else {
            const companyUserPermissions =
              res.data.entities.company_user_permissions;
            for (let permission of companyUserPermissions) {
              if (permission.user_id === Number(this.userId)) {
                isManagerPermission = true;
                break;
              }
            }
          }

          this.setState({
            isManagerPermission,
            hasManagerPermission,
          });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else {
            errorMessage = res.data.message;
          }
          this.setState({ errorDialogFlg: true, errorMessage });
        }
      })
      .catch(error => {
        let errorMessage = '';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.data.message;
        }
        this.setState({ errorDialogFlg: true, errorMessage });
      });
  }

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.getHeaderTitle()}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={this.getHeaderTitle()}
            onClose={() =>
              masterSlideLoader.show('Users', { state: { id: 1 } })
            }
          />
          <UserForm
            userId={this.state.userId}
            viewerId={this.state.viewerId}
            viewMode={USER_VIEW_MODE.DETAIL}
            isPrimary={this.state.isPrimary}
            params={this.state.params}
            blockPermission={this.state.blockPermission}
            isManagerPermission={this.state.isManagerPermission}
            hasManagerPermission={this.state.hasManagerPermission}
            events={this.state.events}
            sideView={
              <SideMenu roleId={this.roleId} targetUserId={this.state.userId} />
            }
            photoInfo={
              isPrimaryCompanyRoleId(this.roleId)
                ? 'こちらは顔認証で使用される画像ではありません。顔認証用の画像はサブメニューの「顔写真」から登録してください。'
                : null
            }
          />
        </div>
      </div>
    );
  }
}

const SideMenu = ({ roleId, targetUserId }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <a className='line-list line-list--contruction-navi-list select'>
          基本情報
        </a>
      </li>
      {isPrimaryCompanyRoleId(roleId) && (
        <li className='contruction-navi-list__item'>
          <a
            className='line-list line-list--contruction-navi-list'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              masterSlideLoader.show('UserPhoto', {
                state: { id: targetUserId },
              });
            }}
          >
            顔写真
          </a>
        </li>
      )}
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/UserDetail.jsx